export default (id, pairs) => {
    for (const key in pairs) {
        if (Number(pairs[key].id) === Number(id)) {
            return pairs[key];
        }
    }

    return null;
}